<template>
    <div id="WordMobile">
        <nav-bar style="background-color: #0092FF">
            <link-mobile slot="left" link="/WordLoadMobile"><i class="el-icon-user"></i></link-mobile>
<!--            <div  slot="center" class="progress" >-->
            <div slot="center">
                <div class="progress">
                    <span class="progress-left" v-show="rWordNum" :style="progressLeftStyle">{{this.rWordNum}}</span>
                    <span class="progress-center" v-show="fWordNum" :style="progressCenterStyle">{{this.fWordNum}}</span>
                    <span class="progress-right" v-show="progressWordNum" :style="progressRightStyle">{{this.wordNum-this.rWordNum-this.fWordNum}}</span>
                </div>
            </div>

            <span slot="right" style="display: flex">
                <div style="flex: 1">
                    <i class="el-icon-headset"></i>
                </div>

                <link-mobile link="/WordMoreMobile" style="flex: 1"><i class="el-icon-more"></i></link-mobile>
            </span>

        </nav-bar>


        <Scroll class="wrapper" ref="scroll"
                :probe-type="3"
                :pull-up-load="true">
            <el-input ref="inputWord" @focus="bbo" @blur="cco" autofocus="autofocus" placeholder="请拼写单词" v-model="inputWord" class="input-with-select" @change="nextPractise">

                <el-select v-model="selectValue"  default-first-option  slot="prepend" :placeholder="$store.state.a.allPlanWordLIst.length>0 ? $store.state.a.allPlanWordLIst[0].startdate:'请选择'" style="width: 100px;" @change="aaa(selectValue)" clearable>
                    <!--                            <el-select v-model="value" placeholder="请选择">-->
<!--                    :placeholder="$store.state.a.allPlanWordLIst.length>0 ? $store.state.a.allPlanWordLIst[0].startdate:'请选择'"-->
                        <el-option
                            :key="$store.state.a.allPlanWordLIst.length>0 ? $store.state.a.allPlanWordLIst[0].startdate:'请刷新'"
                            :disabled="true"
                            :value="$store.state.a.allPlanWordLIst.length>0 ? $store.state.a.allPlanWordLIst[0].startdate:'请刷新'">
                    </el-option>
                    <el-option
                            key="新词"
                            value="新词">
                    </el-option>
                    <el-option
                            v-for="(item,index) in this.$store.state.a.allPlanWordLIst"
                            v-if="index!=0"
                            :key="item.startdate"
                            :label="item.startdate"
                            :value="item.startdate">
                    </el-option>
                    <!--                                <el-option label="ONE" value="2"></el-option>&ndash;&gt;-->
                    <!--                                <el-option :label="item.startdate" :value="item.startdate" v-for="(item,index) in this.$store.state.a.allPlanWordLIst"></el-option>-->
                    <!--                                <el-option label="ONE" value="2"></el-option>-->
                    <!--                                <el-option label="TWO" value="3"></el-option>-->
                    <!--                                <el-option label="THREE" value="4"></el-option>-->
                </el-select>
                <el-button slot="append" icon="el-icon-search" @click="toWordDetailMobile"></el-button>
                <el-button slot="append" icon="el-icon-refresh" @click="refreshWord"></el-button>

            </el-input>
            <div style="background-color: #7DA39A">
                <el-row :gutter="24" style="height: 40px">
                    <el-col :span="24" :style="{'font-size':'35px'}" ><div class="grid-content bg-purple" v-show="isShowWord">{{this.$store.getters.currentCardList[this.$store.state.a.currentCardItemIndex].word}}</div></el-col>
                </el-row>
                <el-row :gutter="24" :style="{'height':'35px'}" >
                    <el-col :span="12" ><div class="grid-content bg-purple" v-show="isShowWord">{{this.$store.getters.currentCardList[this.$store.state.a.currentCardItemIndex].yinjie}}</div></el-col>
                    <el-col :span="12" ><div class="grid-content bg-purple" v-show="isShowWord">{{this.$store.getters.currentCardList[this.$store.state.a.currentCardItemIndex].yinbiao}}</div></el-col>
                </el-row>
                <el-row :gutter="24" style="height: 40px">
                    <el-col :span="24" :style="{'font-size':'15px'}"><div class="grid-content bg-purple">{{this.$store.getters.currentCardList[this.$store.state.a.currentCardItemIndex].fanyi}}</div></el-col>
                </el-row>
            </div>

            <div >
                <el-row :gutter="20" :style="{'height':'44px'}">
                    <el-col :span="6" :style="{'font-size':'25px'}">
                        <el-button @click="turnCheck" style="background-color: #7EE5AD">{{isCheck}}</el-button>
                    </el-col>
                    <el-col :span="6" :style="{'font-size':'25px'}" v-if="$store.state.a.wordListSwitch">
                        <button class="el-button" :style="{'font-size':'13px','padding-left': '15px','padding-top': '9px','text-align':'center','width':'56px','height':'32px','top':'1.5px','position':'relative'}" @mousedown="Show" @mouseup="notShow" @touchstart="Show"  @touchend="notShow">提示</button>
                    </el-col>
                    <el-col :span="6" :style="{'font-size':'25px'}" v-if="!$store.state.a.wordListSwitch">
                        <el-button @click="getNewWordList">新词</el-button>
                    </el-col>
                     <el-col :span="6" :style="{'font-size':'25px'}">
                         <el-button @click="lastWord">上一个</el-button>
                    </el-col>
                     <el-col :span="6" :style="{'font-size':'25px'}">
                         <el-button @click="nextWord">下一个</el-button>
                    </el-col>
                </el-row>
            </div>



        </Scroll>
    </div>
</template>

<script>
    import NavBar from "../../components/navbar/NavBar";
    import Scroll from "../../components/scroll/Scroll";
    import LinkMobile from "../../components/link/LinkMobile";
    import wordMobile_icon_menu_default from "./img/wordMobile_icon_menu_default.svg";
    export default {
        name: "WordMobile",
        components:{

            LinkMobile,
            NavBar,
            Scroll
        },
        data(){
            return{
                selectValue:'',
                reviewList:[
                    // 'list1',
                    // 'list2',
                    // 'list3',
                    // 'list4',

                ],
                wordIndex:0,
                inputWord:'',
                isCheck:'背词',
                isWrite:false,
                isShowWord:true,
                status:true,
                msg:'',
                rWordNum: 0,
                fWordNum:0,
                wordNum:0,
                wordNumIndex:0,
            }
        },
        mounted() {
            this.$store.dispatch('requireWord','bull'),
                this.$store.dispatch('requireRecoverWord').then(res=>{
                    this.$notify({
                        title: '以下单词已经回收，请再次学习',
                        message: res,
                        dangerouslyUseHTMLString:true,
                        type: 'warning'
                    });
                });
            this.$store.dispatch('requireAllPlanWord');

            this.$bus.$on('newWordLoad',this.aaa);
        },
        computed:{
            progressWordNum(){
                return this.wordNum-this.rWordNum-this.fWordNum;
            },
            progressLeftStyle(){
                let width=(this.rWordNum)/this.wordNum*100+"%";
                return {'width': width}
            },
            progressCenterStyle(){
                let width=(this.fWordNum)/this.wordNum*100+"%";
                return {'width': width}
            },
            progressRightStyle(){
                let width=(this.wordNum-this.rWordNum-this.fWordNum)/this.wordNum*100+"%";
                return {'width': width}
            }
        },
        methods:{
            bbo(){
                this.$store.commit('bbb')
            },
            cco(){
                this.$store.commit('ccc')
            },
            recoverProgress(){
                this.rWordNum=0;
                this.fWordNum=0;
                this.wordNumIndex=0;
                setTimeout(() =>{
                    this.wordNum=this.$store.getters.currentCardList.length;
                },500)

            },
            turnCheck(){
                if(this.$store.state.a.wordListSwitch){
                    this.$store.state.a.wordListSwitch=false;
                    this.isCheck='背词';
                    this.isShowWord=true;
                }else{
                    this.$store.state.a.wordListSwitch=true;
                    this.isCheck='默词';
                    this.isShowWord=false;
                }
                this.refreshWord();
            },
            Show(){
                // alert("111");
                this.isShowWord=true;
            },
            notShow(){
                // alert("222");
                this.isShowWord=false;
                this.$nextTick(() => {
                    this.$refs.inputWord.focus()
                },10);
            },
            getNewWordList(){
                this.$store.dispatch('requireNewWord');
                this.$store.dispatch('requireAllPlanWord');
                this.refreshWord();
                this.selectValue='新词';
            },
            aaa(aa){
                // alert(aa);
                // alert(this.selectValue);
                if(aa=='新词'){
                    this.getNewWordList();
                }else{
                    this.$store.dispatch('requireDateWord',aa);
                    this.refreshWord();
                }

            },
            getWordds(){
                // alert("111")
                // this.searchWord =this.$refs.word.value;
                this.$store.dispatch('requireWord',this.searchWord)
            },
            load () {
                this.count += 2
            },
            nextPractise(){
                this.$store.dispatch('checkWord', this.$refs.inputWord.value).then(res => {
                    this.wordIndex=this.$store.state.a.currentCardItemIndex;
                    // this.$store.commit('setIsBackCardWordItem');
                    if(this.status){
                        this.status = false;
                        if(this.msg){
                            this.msg.close();
                        }

                        this.msg=this.$message({
                            message: res + '    已成功打卡!',
                            type: 'success',
                            offset:-4,
                            center:true,
                            duration:5000
                        });
                        this.inputWord='';
                        this.status = true;
                    }


                }).catch(res=>{
                    this.nextWord();
                    if(this.$store.state.a.wordListSwitch){
                        if(this.status){
                            this.status = false;
                            if(this.msg){
                                this.msg.close();
                            }

                            this.msg=this.$message({
                                message: res + '     很遗憾！',
                                type: 'error',
                                offset:-4,
                                center:true,
                                duration:10000
                            });
                            this.status = true;
                        }
                    }

                });
                // this.inputWord='';
            },
            refreshWord(){
                this.wordIndex=0;
                this.$store.commit('setCurrentCardItemIndex',this.wordIndex);
                this.$store.commit('refreshInputList');
                this.$nextTick(() => {
                    this.$refs.inputWord.focus()
                },10);
                this.recoverProgress();
            },
            lastWord(){
                if(this.wordIndex > 0){
                    this.wordIndex--;
                    this.$store.commit('setCurrentCardItemIndex',this.wordIndex);
                }
                this.$nextTick(() => {
                    this.$refs.inputWord.focus()
                },10);
            },
            nextWord(){
                if (this.wordIndex < this.$store.getters.currentCardList.length-1){
                    this.wordIndex++;

                    if(this.wordNumIndex<this.wordIndex){
                        this.wordNumIndex=this.wordIndex;
                        if(this.$refs.inputWord.value==this.$store.getters.currentCardList[this.$store.state.a.currentCardItemIndex].word){
                            this.rWordNum++;
                        }else{
                            this.fWordNum++;
                        }
                    }
                    this.$store.commit('setCurrentCardItemIndex',this.wordIndex);
                }
                // alert(this.wordNumIndex);
                // alert(this.wordNum);
                if(this.wordNumIndex===this.wordNum-1){
                    this.wordNumIndex++;
                    if(this.$refs.inputWord.value==this.$store.getters.currentCardList[this.$store.state.a.currentCardItemIndex].word){
                        this.rWordNum++;
                    }else{
                        this.fWordNum++;
                    }
                }
                this.$nextTick(() => {
                    this.$refs.inputWord.focus()
                },10);
                this.inputWord='';
            },
            toWordDetailMobile(){
                this.$router.replace("/WordDetailMobile");
                this.$store.dispatch('requireWord',this.$store.getters.currentCardList[this.$store.state.a.currentCardItemIndex].word);
            }
        }
    }
</script>

<style scoped>
    #WordMobile{
        height: 100vh;
    }
    .wrapper{
        position: relative;
        height: calc(100% - 93px);
        /*height: 580px;*/
        /*background-color: red;*/
        overflow: hidden;
        /*overflow: hidden;*/
        position: relative;
        padding-left: 0px;
    }
    .progress{
        line-height: 20px;
        margin-top: 5%;
        display: flex;
    }
    .progress-left{
        /*width: 30%;*/
        background-color: #449d44;
    }
    .progress-center{
        /*width: 30%;*/
        background-color: red;
    }
    .progress-right{
        /*width: 30%;*/
        background-color: gray;
    }
</style>